import React from 'react';
import AppendInput from '../../../../component/form/AppendInput';

function TotalBillFooter({
	calculateTotalBill,
	error,
	additionDiscountAndTax,
	subTotal,
	setAdditionDiscountAndTax,
}) {
	return (
		<div className="total-bill-footer">
			<div className="credit-note-summary">
				<div className="max-w-1297 px-3 py-3">
					<div className="row align-items-center mb-3">
						<div className="col-auto">
							<label className="fw-medium mb-0">Discount</label>
						</div>
						<div className="col-12 col-sm-12 col-md-6">
							<AppendInput
								label=""
								placeholder="0"
								appendLabel="%"
								type="text"
								className="custom-append-text"
								error={error?.payment_amount}
								value={additionDiscountAndTax?.discount}
								onChange={(valueData) => {
									let value = valueData?.replace(/[^0-9.]/g, '');
									const decimalCount = (value.match(/\./g) || []).length;
									if (decimalCount > 1) {
										value = +value?.slice(0, value.lastIndexOf('.'));
									}
									setAdditionDiscountAndTax((prev) => ({
										...prev,
										discount: value,
									}));
								}}
							/>
						</div>
					</div>
					<div className="d-flex flex-wrap justify-content-end align-items-center  gap-4 bill-summary-row">
						<div className="d-flex align-items-center gap-2">
							<span className="fw-medium">Sub Total:</span>
							<span>₹{subTotal.toFixed(2)}/-</span>
						</div>
						<div className="d-flex align-items-center gap-2">
							<span className="fw-medium">Taxes:</span>
							<span>
								₹{additionDiscountAndTax.taxes.toFixed(2)}/-
							</span>
						</div>
						<div className="d-flex align-items-center gap-2 fw-bold">
							<span>Bill Total:</span>
							<span>
								₹{calculateTotalBill().toFixed(2)}/-
							</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default TotalBillFooter;
